import React from 'react';

const DesignLabHeader = ({ onAddEquipment, styles }) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        {/* Page title - uses pageTitleWeight/Size/Color */}
        <h1 className={`${styles.pageTitleSize || 'text-2xl'} ${styles.pageTitleWeight || styles.fontWeight} ${styles.pageTitleColor || 'text-gray-900'} ${styles.tracking || ''}`}>
          Equipment Register
        </h1>
        {/* Description - uses descriptionColor/Size */}
        <p className={`${styles.descriptionColor || 'text-gray-500'} mt-1 ${styles.descriptionSize || styles.fontSize}`}>
          Live Design Lab - Testing UI Variants
        </p>
      </div>
      {/* Button - uses buttonTextWeight/Size */}
      <button
        onClick={onAddEquipment}
        className={`px-4 py-2 bg-blue-600 text-white ${styles.rounded} ${styles.shadow} hover:bg-blue-700 transition ${styles.buttonTextWeight || styles.fontWeight} ${styles.buttonTextSize || styles.fontSize}`}
      >
        + Add Equipment
      </button>
    </div>
  );
};

export default DesignLabHeader;
